import { StrictNullable } from '@/shared/types/app.types'
import { AccountingUnitResponse } from '@/api/services/billing/common-accounting-unit/billing-common-accounting-unit.dto'

export interface ConfigurationAccountingUnitModalBasicFormUnit {
    id: StrictNullable<number>
    name: string
    symbol: string
    code: string
    active: boolean
    isDefault: boolean
}

export interface ConfigurationAccountingUnitModalBasicFormState {
    originalAccountingUnit: StrictNullable<AccountingUnitResponse>
    accountingUnit: ConfigurationAccountingUnitModalBasicFormUnit
}
export const initialConfigurationAccountingUnitModalBasicFormState =
    (): ConfigurationAccountingUnitModalBasicFormState => ({
        originalAccountingUnit: null,
        accountingUnit: {
            id: null,
            name: '',
            symbol: '',
            code: '',
            active: true,
            isDefault: false
        }
    })
